import { trpc } from '@/shared/api/trpc';

const useInvalidateOrg = () => {
  const utils = trpc.useUtils();
  return (id: string) => {
    utils.organizations.findOne.invalidate({ id });
    utils.auth.me.invalidate();
  };
};

/**
 * Assign Travefy export credentials for the organization (XT-163). Keys come
 * from Travefy and are unique per org — operators paste both values after
 * purchase. Export stays disabled until this succeeds.
 */
export const useSetTravefyCredentials = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.setTravefyCredentials.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};

/** Clear Travefy credentials — export is disabled until keys are reassigned. */
export const useClearTravefyCredentials = () => {
  const invalidate = useInvalidateOrg();
  return trpc.organizations.clearTravefyCredentials.useMutation({
    onSettled: (_data, _err, vars) => {
      if (vars?.id) invalidate(vars.id);
    },
  });
};
